import { useQuery } from "@tanstack/react-query";
import { api } from "@/shared/api";
import { useAuth } from "@/contexts/AuthContext";
import { useImpersonationOptional } from "@/contexts/ImpersonationContext";
import type { AdvisorIdentityEnvelope } from "./identityTypes";

/**
 * 军师 launcher 可见门控。
 * 显示 ⟺ 非代客 && 当前是租户身份 && 当前登录用户被授权 agent_access。
 * agentAccess 走免权益闸端点 GET /advisor/identity(console 现有身份源 useAuth/permissions 不含此字段)。
 * fail-closed:请求失败或未 enabled 一律 canUseAdvisor=false,宁可不显示也不让没授权的人误进挨 403。
 */
export function useAdvisorAccess() {
  const { user, effectiveScope } = useAuth();
  const { isImpersonating } = useImpersonationOptional();
  const enabled = !isImpersonating && effectiveScope === "TENANT";

  const q = useQuery<AdvisorIdentityEnvelope>({
    // queryKey 带身份:QueryClient 是 module 单例,跨软登出/登录存活;不含身份会让下一个用户
    // 命中上一个用户的 agentAccess 缓存(staleTime Infinity 永不 refetch)→ 付费门控漏出/误挡。
    queryKey: ["advisor", "identity", user?.tenantCode, user?.userId],
    queryFn: () => api.get<AdvisorIdentityEnvelope>("/advisor/identity"),
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });

  return {
    canUseAdvisor: enabled && q.data?.agentAccess === true,
    loading: enabled && q.isLoading,
  };
}
